var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h3',[_vm._v(" Vis Audio ")]),_c('p',[_vm._v(" This is a visualized audio player based on Web Audio API. ")])])}]

export { render, staticRenderFns }